module.exports = __webpack_public_path__ + "img/etc-etc-new-arrow-r-b.3e30912c.svg";